import blueChameleon from './animals/blue-chameleon.png'
import blueToucan from './animals/blue-toucan.png'
import orangeChameleon from './animals/orange-chameleon.png'
import orangeToucan from './animals/orange-toucan.png'
import BoardBack from './board/boardBack.jpg'
import BoardFront from './board/boardFront.jpg'
import blueMosquito from './token/blue-mosquito.jpg'
import goldenMosquito from './token/golden-mosquito.jpg'
import greyMosquito from './token/grey-mosquito.jpg'
import redMosquito from './token/red-mosquito.jpg'
import waterlilyFlower from './token/waterlily-flower.jpg'
import waterlily from './token/waterlily.jpg'
import whiteMosquito from './token/white-mosquito.jpg'

const Images = {
  BoardBack, BoardFront, blueChameleon, orangeChameleon, blueToucan, orangeToucan,
  blueMosquito, goldenMosquito, greyMosquito, redMosquito, whiteMosquito, waterlily, waterlilyFlower
}

export default Images

